import { ESize } from "@/interfaces/enums";
import { Container } from "../Container";
import { Logo } from "../Logo";
import { HeaderProps } from "./Header.interfaces";

export const Header = ({ children, logo }: HeaderProps) => {
  return(
    <header className="relative bg-white index-2 shadow-lg">
      <Container additionalClassNames="relative py-3 flex flex-row items-center" size={ESize.Full}>
        <Logo {...logo} />
        {children}
      </Container>
    </header>
  )
};